import { TextInput } from '../baseInputs'

type Props = {
  helper?: string
}

const FullName = ({ helper, ...rest }: Props) => {
  const name = 'full_name'
  const label = 'Full name'

  return <TextInput name={name} label={label} helper={helper} {...rest} />
}

export default FullName
